<dsh-filter
    *transloco="let t; scope: 'refund-status-filter'; read: 'refundStatusFilter'"
    [active]="isActive"
    [label]="t('label')"
    [activeLabel]="savedValue | refundStatusLabel | async"
    [content]="content"
    (save)="save()"
    (clear)="clear()"
>
</dsh-filter>
<ng-template #content>
    <dsh-refund-status-field [formControl]="control"></dsh-refund-status-field>
</ng-template>
